const axios = require("axios");

module.exports = {
	api: axios.create({
		baseURL: process.env.REACT_APP_API,
	}),
};
